import {InjectionToken, TemplateRef} from "@angular/core";

export const PORTAL_ELEMENTS_TOKEN = new InjectionToken<TemplateRef<any>>('portal token');